import { BASE_URL, BASE_JOIN_URL, BASE_MAIN_URL } from 'consts/urls';
import { QueryClient } from '@tanstack/react-query';

//useQuery 계속 콜되는 막기, refetch 할때만 콜하기
export const getClient = (() => {
  let client: QueryClient | null = null;
  return () => {
    if (!client)
      client = new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 0,
            gcTime: Infinity,
            refetchOnMount: true,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            enabled: false
          }
        }
      });
    return client;
  };
})();

export const restfetcher = async ({
  method,
  path,
  params
}: {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  path: string;
  params?: { [key: string]: any | FormData };
}) => {
  try {
    const token = typeof sessionStorage !== 'undefined' ? sessionStorage?.getItem('token') : null;

    const onlyJoinApi = path.includes('biz/auth/join') ? BASE_JOIN_URL : BASE_URL;
    // const onlyJoinApi = path.includes('biz/auth/join')
    //   ? BASE_JOIN_URL
    //   : path.includes('v1/auth')
    //   ? BASE_MAIN_URL
    //   : path.includes('api/auth')
    //   ? BASE_MAIN_URL
    //   : BASE_URL;

    const url = path.includes('http') ? path : `${onlyJoinApi}${path}`;
    const fetchOptions: any = {
      method
    };

    const needTokenPaths = [
      'biz/mypage/search/authinfo',
      'biz/membership/subscribe',
      'biz/exapparatus/save/sample',
      'biz/auth/info',
      'biz/mypage/search/authinfo',
      'biz/mypage/update/bizlicenseurl',
      'biz/mypage/set/bankbook',
      'biz/sales/find',
      'biz/my/membership/device/check',
      'biz/my/membership/device/delete',
      'biz/my/membership/device/membership/save',
      'biz/sales/annualsales',
      'biz/sales/service/year'
    ];

    // 현재 `path`가 `specialPaths` 배열에 포함되어 있는지 확인
    const isNeedTokenPath = needTokenPaths.includes(path);

    if (params) {
      if (params instanceof FormData) {
        fetchOptions.body = params;
        const isJoin = path.includes('biz/auth/join');

        fetchOptions.headers = isJoin
          ? {}
          : {
              Authorization: `Bearer ${token}`
            };
      } else if (isNeedTokenPath) {
        fetchOptions.body = JSON.stringify(params);
        fetchOptions.headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        };
      } else {
        fetchOptions.body = JSON.stringify(params);
        fetchOptions.headers = {
          'Content-Type': 'application/json'
          // Authorization: `Bearer ${token}`,
        };
      }
    } else {
      return false;
    }

    const res = await fetch(url, fetchOptions);
    const json = await res?.json();

    if (!res.ok || json?.errcode === 401) {
      if (res.status === 401 || (res.status === 200 && token)) {
        const refresh = localStorage?.getItem('refresh');
        const fetchOptionsToken: any = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        if (refresh && token) {
          fetchOptionsToken.body = JSON.stringify({ token: refresh });
          const refreshedToken = await fetch(`${BASE_URL}v1/auth/token`, fetchOptionsToken);
          const refreshedTokenJson = await refreshedToken?.json();
          const authenticatetoken = refreshedTokenJson?.authenticatetoken;

          if (authenticatetoken) {
            const { jwt, refresh } = authenticatetoken;
            if (refreshedToken && jwt && refresh) {
              if (typeof sessionStorage !== 'undefined') {
                sessionStorage?.setItem('token', jwt);
                localStorage?.setItem('refresh', refresh);
              }
              fetchOptions.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
              };
              const refreshedResponse = await fetch(url, fetchOptions);
              const refreshedResult = await refreshedResponse.json();
              // setData(refreshedResult);
              return refreshedResult;
            } else {
              if (refreshedTokenJson.status === 403 || !jwt) {
                if (typeof sessionStorage !== 'undefined') {
                  sessionStorage?.clear();
                  localStorage?.removeItem('refresh');
                }

                if (window && window.location) {
                  window.location.pathname = '/';
                }
                alert('토큰 갱신에 실패하였습니다. 세션 만료로 자동 로그아웃 되었습니다.');
              }
            }
          } else {
            if (typeof sessionStorage !== 'undefined') {
              sessionStorage?.clear();
              localStorage?.removeItem('refresh');
            }

            if (window && window.location) {
              window.location.pathname = '/';
            }

            alert('세션 만료로 자동 로그아웃 되었습니다.');
            sessionStorage?.clear();
            localStorage?.removeItem('refresh');
          }
        } else {
          if (typeof sessionStorage !== 'undefined') {
            sessionStorage?.clear();
            localStorage?.removeItem('refresh');
          }

          if (window && window.location) {
            window.location.pathname = '/';
          }
          alert('세션 만료로 자동 로그아웃 되었습니다.');
          sessionStorage?.clear();
          localStorage?.removeItem('refresh');
        }
      } else {
        console.log(res.status);
      }
      throw new Error(`Error! status: ${res.status}`);
    } else {
      return json;
    }
  } catch (error) {
    console.error(error);
  }
};

export const QueryKeys = {
  SENDAUTHMAIL: 'SENDAUTHMAIL',
  AUTHCODE: 'AUTHCODE',
  RECOMMENDCODE: 'RECOMMENDCODE',
  JOIN: 'JOIN',
  MYPAGEINFO: 'MYPAGEINFO',
  EDIT_BIZ_NAME: 'EDIT_BIZ_NAME',
  EDIT_BIZ_ADDRESS: 'EDIT_BIZ_ADDRESS',
  EDIT_BIZ_NUMBER: 'EDIT_BIZ_NUMBER',
  EDIT_BIZ_LICENSENUMBER: 'EDIT_BIZ_LICENSENUMBER',
  EDIT_BIZ_ACCOUNT: 'EDIT_BIZ_ACCOUNT',
  EDIT_BIZ_ACCOUNT_IMAGE: 'EDIT_BIZ_ACCOUNT_IMAGE',
  EDIT_BIZ_LICENSE_IMAGE: 'EDIT_BIZ_LICENSE_IMAGE',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  CATEGORYTYPE: 'CATEGORY_TYPE',
  BUSINESSTYPE: 'BUSINESS_TYPE',
  SALESTYPE: 'SALES_TYPE',
  VALIDJOIN: 'VALID_JOIN',
  USERINFO: 'USERINFO',
  MEMBERSHIP: 'MEMBERSHIP',
  SUBSCRIBE: 'SUBSCRIBE',
  SAVE_SAMPLE: 'SAVE_SAMPLE',
  BOARD_MENU: 'BOARD_MENU',
  BOARD_SEARCH: 'BOARD_SEARCH',
  BOARD_SEARCH_FAQ: 'BOARD_SEARCH_FAQ',
  BOARD_SEARCH_NOTICE: 'BOARD_SEARCH_NOTICE',
  SALES_MANAGEMENT: 'SALES_MANAGEMENT',
  INCREASE_VIEW: 'INCREASE_VIEW',
  DEVICES: 'DEVICES',
  EDIT_DEVICE_NAME: 'EDIT_DEVICE_NAME',
  EDIT_TERMINAL_ID: 'EDIT_TERMINAL_ID',
  EDIT_TERMINAL: 'EDIT_TERMINAL',
  EDIT_PRINT: 'EDIT_PRINT',
  EDIT_MEMBERSHIP: 'EDIT_MEMBERSHIP',
  DELETE_DEVICE: 'DELETE_DEVICE',
  EDIT_MEMBERSHIP_CHECK: 'EDIT_MEMBERSHIP_CHECK',
  SALES_MONTHLY: 'SALES_MONTHLY',
  SAELS_YEARS: 'SAELS_YEARS',
  MEMBERSHIP_BILLING: 'MEMBERSHIP_BILLING',
  MEMBERSHIP_SUBSCRIBE_DETAIL: 'MEMBERSHIP_SUBSCRIBE_DETAIL',
  PAYMENT_LIST: 'PAYMENT_LIST',
  PAYMENT_DETAILS_LIST: 'PAYMENT_DETAILS_LIST',
  PRESIGN_UP_DATA: 'PRESIGN_UP_DATA',
  NATION_LIST: 'NATION_LIST'
};
